import { render, staticRenderFns } from "./NotificationsEv.vue?vue&type=template&id=2aac1f1b&scoped=true"
import script from "./NotificationsEv.vue?vue&type=script&lang=js"
export * from "./NotificationsEv.vue?vue&type=script&lang=js"
import style0 from "./NotificationsEv.vue?vue&type=style&index=0&id=2aac1f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aac1f1b",
  null
  
)

export default component.exports